@if (mainStream$ | async; as mainStream) {
    @if (itemsLimitIsReached$ | async) {
        <h-message-block [autoAddPadding]="false" [showBackground]="false" [type]="'info'">
            <ng-container i18n="@@hermes.store_locator.refine_your_search"> Please refine your search</ng-container>
        </h-message-block>
    } @else {
        @if (mainStream.displayWarningMessage) {
            <h-message-block [autoAddPadding]="false" [showBackground]="false" [type]="'info'">
                <ng-container i18n="@@page-hermes-store-locator-no-store-close-msg">
                    There is no nearby store but here are the closest matches
                </ng-container>
            </h-message-block>
        }
        <h2 class="sr-only" id="stores-found-msg">
            {{ mainStream.visibleShopIds.length }}
            @if (mainStream.visibleShopIds?.length || 0 > 1) {
                <ng-container i18n="@@page-hermes-product-locator-stores-found-msg"> stores found</ng-container>
            }
            @if (mainStream.visibleShopIds?.length || 0 <= 1) {
                <ng-container i18n="@@page-hermes-product-locator-store-found-msg"> store found</ng-container>
            }
        </h2>

        @if (mainStream.visibleShopIds; as visibleShopIds) {
            <ul [attr.aria-labelledby]="'stores-found-msg'">
                @for (shopId of visibleShopIds; track shopId; let i = $index) {
                    <li
                        #shopListElements
                        [id]="'shop-item-' + i"
                        class="shop"
                        [class.hoverable]="true"
                        [class.hovered]="(shopLocatorFacade.hoveredShopId$ | async) === shopId"
                        (mouseenter)="setHoveredShop(shopId)"
                        (mouseleave)="shopLocatorFacade.unsetHoveredShop()">
                        <h-shop-info
                            [linkMode]="'internal'"
                            [shop]="mainStream.shops[shopId]"
                            [directionLinkMode]="
                                mainStream.extraInfos[shopId]?.directionUrl !== undefined ? 'icon' : 'none'
                            "
                            [meters]="mainStream.extraInfos[shopId]?.meters ?? 0"
                            [directionUrl]="mainStream.extraInfos[shopId]?.directionUrl ?? ''"
                            [sectionsToDisplay]="sectionsToDisplay()"
                            (shopInfoEvents)="shopInfoEvent($event, shopId, i + 1)">
                        </h-shop-info>
                    </li>
                }
            </ul>
        }
    }
}
